<div class="p-grid">
    <div class="p-col-10 m-auto">
        <div class="p-d-flex p-jc-between p-ai-end">
            <h1 class="p-mr-5 p-ml-5 p-mt-5">{{'GLOBAL.DOCUMENTACION.VEHICULO' | translate}}</h1>
        </div>
        <div class="delim p-ml-5 p-mr-5"></div>
        <form class="p-m-5" name="documentacionForm" #documentacionForm="ngForm">
            <div class="p-grid p-mb-2">
                <div class="p-col-12">
                    <h3>{{'VEHICULO.DOCUMENTOS' |translate}}</h3>
                    <p-dataView [value]="documentos" layout="list" [emptyMessage]="'VEHICULOS.AÑADA.DOCUMENTOS' | translate">
                        <p-header>
                            <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                                <div class="p-col-3">{{'GLOBAL.TIPO' |translate}}</div>
                                <div class="p-col-3">{{'GLOBAL.FECHA.VENCIMIENTO' |translate}}</div>
                                <div class="p-col-2">{{'GLOBAL.ESTADO' |translate}}</div>
                                <div class="p-col-2">{{'GLOBAL.ARCHIVO' |translate}}</div>
                                <div class="p-col-2">{{'GLOBAL.ACCIONES' |translate}}</div>
                            </div>
                        </p-header>
                        <ng-template let-documento let-ri="rowIndex" pTemplate="listItem">
                            <div class="p-col-12 p-d-flex p-jc-between p-2 documento-list" *ngIf="ri !== documentos.length -1">
                                <div class="p-col-3">{{documento.tipoDocumento.nombre}}</div>
                                <div class="p-col-3" *ngIf="documento.fechaVencimiento !== undefined">{{documento.fechaVencimiento}}</div>
                                <div class="p-col-3" *ngIf="documento.fechaVencimiento === undefined">N/A</div>

                                <div class="p-col-2">
                                    <!--Aqui es donde se cargan los archivos-->
                                    <button pButton *ngFor="let imagen of documento.imagen" icon="fas fa-file" [label]="'GLOBAL.ABRIR' | translate" class="p-button-rounded p-button-warning p-mb-2 w-75" [pTooltip]="imagen.nombre" tooltipPosition="top" (click)="downloadDocument(imagen)"></button>
                                </div>
                                <div class="p-col-2">
                                    <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" [pTooltip]="'GLOBAL.ELIMINAR' | translate" tooltipPosition="top" (click)="deleteDocumento(documento)"></button>
                                </div>
                            </div>

                            <div class="p-col-12 p-d-flex p-jc-between p-2 p-ai-center" *ngIf="ri === documentos.length -1">
                                <div class="p-col-3">{{documento.tipoDocumento.nombre}}</div>
                                <div class="p-col-3" *ngIf="documento.fechaVencimiento !== undefined">{{documento.fechaVencimiento}}</div>
                                <div class="p-col-3" *ngIf="documento.fechaVencimiento === undefined">N/A</div>

                                <div class="p-col-2">
                                    <button pButton *ngFor="let imagen of documento.imagen" icon="fas fa-file" [label]="'GLOBAL.ABRIR' | translate" class="p-button-rounded p-button-warning p-mb-2 w-75" [pTooltip]="imagen.nombre" tooltipPosition="top" (click)="downloadDocument(imagen)"></button>
                                </div>
                                <div class="p-col-2">
                                    <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" [pTooltip]="'GLOBAL.ELIMINAR' | translate" tooltipPosition="top" (click)="deleteDocumento(documento)"></button>
                                </div>
                            </div>
                        </ng-template>
                        <p-footer class="p-d-flex p-jc-end">
                            <div class="p-col-6 p-d-flex p-jc-end">
                                <button pButton icon="pi pi-plus" [label]="'GLOBAL.AÑADIR' | translate" class="p-button-rounded p-button-warning w-25" [pTooltip]="'GLOBAL.AÑADIR' | translate" tooltipPosition="top" (click)="addDocumento()"></button>
                            </div>
                        </p-footer>
                    </p-dataView>
                    <div>
                      {{'REGISTRO.DOCUMENTOS.OBLIGATORIOS' | translate}}
                    </div>
                    <div class="p-mt-2">
                        {{'REGISTRO.DOCUMENTOS.OBLIGATORIOS.DOBLE.ASTERISCO' | translate}}
                    </div>
                </div>
            </div>
            <div class="p-grid p-jc-between p-mb-2">
                <div class="p-col-2">
                    <button class="pr-2 pl-2 pb-1 pt-1" pButton [label]="'GLOBAL.VOLVER' | translate" (click)="volver()"></button>
                </div>
                <div class="p-col-2 p-d-flex p-jc-end">
                    <button class="pr-2 pl-2 pb-1 pt-1" type="submit" [disabled]="!isAllDocuments" pButton [label]="'GLOBAL.SIGUIENTE' | translate" (click)="finalizar()"></button>
                </div>
            </div>
        </form>
    </div>
</div>


<!-- Modal Añadir documento -->
<p-dialog *ngIf="visibleAddDocumento" [(visible)]="visibleAddDocumento" [contentStyle]="{height: '100%'}" [style]="{width: '550px', height: '600px'}" [resizable]="false" [header]="'VEHICULO.AÑADIR.DOCUMENTO' | translate" [modal]="true">
    <form #formNewDocumento="ngForm">
        <div class="p-grid p-mb-5 p-mt-3">
            <div class="p-col-12 p-d-flex p-jc-center">
                <label class=" w-25 p-mr-2">{{'GLOBAL.TIPO.DOCUMENTO' |translate}}*</label>
                <p-dropdown class="w-75" name="tipoDocumentoNewDocumento" [options]="selectTiposDocumentos" required placeholder="Seleccionar" [(ngModel)]="tipoDocumentoNewDocumento" optionLabel="nombre" [required]="true" styleClass="w-100" (onChange)="resetearVariables()"></p-dropdown>
            </div>
            <div class="p-col-12 p-d-flex p-jc-center" *ngIf="tipoDocumentoNewDocumento && (tipoDocumentoNewDocumento.id === 1 || tipoDocumentoNewDocumento.id === 3)">
                <label class=" w-25 p-mr-2">{{'GLOBAL.FECHA.VENCIMIENTO' |translate}}*</label>
                <p-calendar class="w-75" name="fechaVencimientoNewDocumento" [locale]="localeCalendar" [minDate]="minDate" [(ngModel)]="fechaVencimientoNewDocumento" styleClass="w-100" dateFormat="dd/mm/yy" inputId="spanish"></p-calendar>
            </div>
            <div *ngIf="mostrarArchivos" class="p-col-12">
                <label for="nuevosDocumentos">{{'GLOBAL.DOCUMENTOS' |translate}}*</label>
                <p-fileUpload name="nuevosDocumentos" 
                              [chooseLabel]="'GLOBAL.AÑADIR' | translate" 
                              [multiple]="true" 
                              [showUploadButton]="false" 
                              [accept]="acceptTypeDocument" 
                              [showCancelButton]="false" 
                              (onRemove)="deleteNewDocumento($event)" 
                              (onSelect)="addNewDocumento($event)">
                </p-fileUpload>
            </div>
            <div class="p-col-12 p-d-flex p-jc-center">
                <button pButton pRipple [label]="'GLOBAL.CANCELAR' | translate" icon="pi pi-times" class="p-button-text p-mr-3" (click)="cancelNewDocumento()"></button>
                <button pButton pRipple [label]="'GLOBAL.GUARDAR' | translate" icon="pi pi-check" [disabled]="formNewDocumento.form.invalid || newDocumentos.length === 0" class="p-button-text" (click)="saveNewDocumento()"></button>
            </div>
            <p>{{'GLOBAL.CAMPOS.REQUERIDOS' |translate}}</p>
        </div>
    </form>
</p-dialog>

<p-confirmDialog [header]="'GLOBAL.CONFIRMACION' | translate" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<dum-toast #dumToast></dum-toast>
